<template>
  <table class="table">
    <thead>
      <tr>
        <th v-for="column in columns"
            :key="column.id">
          {{ column.title }}
        </th>
      </tr>
    </thead>
    <PlaceHolderTableBody :row-num="rowNum" :col-num="columns.length" />
  </table>
</template>

<script>
  import PlaceHolderTableBody from './PlaceHolderTableBody'

  export default {
    components: {
      PlaceHolderTableBody
    },
    props: {
      rowNum: {
        type: Number,
        default: 3
      },
      columns: {
        type: Array,
        default() {
          return [
            {id: 'id', title: 'Post ID'},
            {id: 'userId', title: 'User ID'},
            {id: 'title', title: 'Title'},
          ]
        }
      },
    },
    data() {
      return {
      }
    }
  }
</script>

<style scoped>

</style>
